import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';

    public data: any = {
        username: '',
        password: ''
    };

    public signupData: any = {
        name: '',
        username: '',
        password: '',
        passwordConfirm: ''
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/";
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async switchView(view: string) {
        this.view = view;
        await this.service.render();
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.username) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            location.href = "/";
            await this.service.render();
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }

    public async signup() {
        let form = JSON.parse(JSON.stringify(this.signupData));
        if (!form.name) {
            await this.alert("이름을 입력해주세요.");
            return;
        }
        if (!form.username) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (form.username.length < 4) {
            await this.alert("아이디는 4자 이상이어야 합니다.");
            return;
        }
        if (!form.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }
        if (form.password.length < 8) {
            await this.alert("비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (form.password !== form.passwordConfirm) {
            await this.alert("비밀번호가 일치하지 않습니다.");
            return;
        }

        let { code, data } = await wiz.call("signup", {
            name: form.name,
            username: form.username,
            password: form.password
        });

        if (code == 200) {
            location.href = "/";
        } else {
            await this.alert(data.message || "회원가입에 실패했습니다.", 'error');
        }
    }
}

export default PageAccessComponent;